<template>
  <div class="">
    <div class="d-flex flex-row align-center justify-space-between mb-4">
      <div class="top-header mb-0">Bookings</div>
    </div>

    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>

    <div class="d-flex flex-row align-center justify-space-between mb-5">
      <div class="d-flex flex-row align-center">
        <v-text-field
          @keydown.enter="getBookings()"
          v-model="qSearch"
          solo
          dense
          flat
          :label="$t('SearchAccounts') + '...'"
          style="max-width: 250px; border-radius: 8px"
          hide-details
        >
          <img
            slot="prepend-inner"
            width="20px"
            height="20px"
            src="/icons/search.svg"
          />
        </v-text-field>
        <v-btn
          depressed
          tile
          class="text-capitalize white--text ml-5"
          color="#0F52BC"
          @click="getSales()"
        >
          <img width="32px" height="32px" src="/icons/reload.svg" />
          {{ $t("Reload") }}</v-btn
        >
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="request"
      :options.sync="options"
      :server-items-length="totalSales"
      :loading="loadingTable"
      :loading-text="`${$t('Loading')}... ${$t('PleaseWait')}`"
      :footer-props="footerProps"
    >
      <template v-slot:[`item.edit`]="{ item }">
        <v-icon
          class="cursor--pointer red--text ml-1"
          @click="remove(item._id)"
        >
          mdi-trash-can
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog"
      max-width="320"
      :disabled="loadingDelete"
      :persistent="loadingDelete"
    >
      <v-card>
        <v-card-text class="pt-3">
          <div class="text-body-1">Do you want remove the bookings?</div>
          <v-progress-linear
            v-if="loadingDelete"
            class="my-2"
            indeterminate
            rounded
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="grey" text @click="dialog = false"> cancel </v-btn>

          <v-btn
            color="error"
            :disabled="loadingDelete"
            depressed
            @click="removeBooking"
          >
            remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import { Permission } from "@/utils/permissions";
import { permissionMixin } from "@/utils/mixins";
import { vdataTable } from "@/plugins/vuetify-custom-props";
import RestResourceBookings from "@/api/apiBookingsService";
import { getAPI } from "@/api/axios-base";
export default {
  name: "BookingsList",
  mixins: [permissionMixin],
  data() {
    return {
      loadingTable: false,
      request: [],
      options: {},
      footerProps: {
        ...vdataTable.footerProps,
        prevIcon: "mdi-chevron-left orange--text text--darken-2",
        nextIcon: "mdi-chevron-right orange--text text--darken-2",
      },
      totalSales: 0,
      qSearch: "",
      errorAlert: false,
      errorMsg: "",
      filterParams: {
        name: null,
        lastname: null,
      },
      headers: [
        {
          text: "Vin - Truck",
          align: "start",
          sortable: false,
          value: "vin",
        },{
          text: "Name", sortable: false, value: "name"},
        { text: "Lastname", value: "lastname", sortable: false },
        { text: "Address", value: "current_address", sortable: false },
        { text: "Street", value: "street_address", sortable: false },
        { text: "City", value: "city", sortable: false },
        { text: "State", value: "state", sortable: false },
        { text: "Social Security", value: "social_security", sortable: false },
        { text: "Phone", value: "phone", sortable: false },
        {
          text: this.$t("Edit"),
          width: 150,
          align: "end",
          sortable: false,
          value: "edit",
        },
      ],
      dialog: false,
      idBooking: null,
      loadingDelete: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.getBookings();
      },
      deep: true,
    },
  },
  computed: {
    editPencilPerms() {
      return [Permission.EDIT_ADMIN];
    },
    createBtnPerms() {
      return [Permission.ADD_ADMIN];
    },
  },
  methods: {
    getBookings() {
      if (this.qSearch.length >= 1 && this.qSearch.length <= 2) {
        this.errorAlert = true;
        this.errorMsg = "The search must have 3 or more characters.";
        return;
      }
      this.loadingTable = true;
      RestResourceBookings.prototype
        .getBookings(this.getParams())
        .then((response) => {
          if (response.status === ResponseStatus.OK) {
            this.totalSales = response.data.total;
            this.request = response.data.data;
          }
        })
        .catch((error) => {
          this.errorMsg = error.response.data.message;
          this.errorAlert = true;
        })
        .finally(() => {
          this.loadingTable = false;
        });
      this.loadingTable = false;
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      let params = {
        q: this.qSearch || null,
        skip: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
      };
      params = { ...params, ...this.filterParams };
      return params;
    },
    remove(id) {
      this.idBooking = id;
      this.dialog = true;
    },
    removeBooking() {
      const url = "api/rest/v1/bookings/" + this.idBooking;

      this.loadingDelete = true;
      getAPI.delete(url).then(() => {
        this.loadingDelete = false;
        this.dialog = false;
        this.getBookings();
      });
    },
  },
};
</script>
  
  <style>
.admin-filter-input >>> .v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
  font-size: 1rem !important;
  font-weight: 200;
}
.admin-filter-input >>> .v-select__slot .v-input__append-inner {
  margin-top: 5px !important;
}
.admin-filter-input >>> .v-select__selections {
  font-size: 12px;
}
</style>
  
